import axios from '@/user/axios'
import AMC_REPORT_TYPE from '@/constants/AmcReportType'
import { fileDownload } from '@/utils'

const moduleAmcBrandReports = {
  namespaced: true,
  state: {
    reportConfigs: [],
    reports: [],
    campaignList: [],
    lineItemList: [],
    segmentList: [],
    categoriesList: [],
    minStartDay: null
  },
  mutations: {
    SET_REPORT_CONFIGS(state, payload) {
      state.reportConfigs = payload
    },
    SET_REPORTS_DATA (state, payload) {
      state.reports = payload
    },
    SET_CAMPAIGN_LIST (state, payload) {
      state.campaignList = payload
    },
    SET_LINE_ITEM_LIST (state, payload) {
      state.lineItemList = payload
    },
    SET_SEGMENT_LIST (state, payload) {
      state.segmentList = payload
    },
    SET_CATEGORIES_LIST (state, payload) {
      state.categoriesList = payload
    },
    SET_MIN_START_DAY (state, payload) {
      state.minStartDay = payload
    }
  },
  getters: {
    enabledCount (state) {
      let sum = 0
      state.reportConfigs.map(c => { if(c.enabled === 1) sum++ })
      return sum
    }
  },
  actions: {
    listBrandReport(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/configs/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_REPORT_CONFIGS', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    updateBrandReport(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.put(`/api/amc-reports/brand-report/${sellerId}/${payload.reportId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    updateEnabled (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.put(`/api/amc-reports/brand-report/enable/${sellerId}/${payload.reportId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    deleteBrandReport (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.delete(`/api/amc-reports/brand-report/${sellerId}/${payload.reportId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addBrandReport (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/amc-reports/brand-report/${sellerId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listCampaign (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/campaign/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_CAMPAIGN_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listLineItem (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/line-item/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_LINE_ITEM_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listSegment (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/segment/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_SEGMENT_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listCategories (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/categories/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_CATEGORIES_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchMinStartDay (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/start-day/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_MIN_START_DAY', res.data.data.startDay)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchReports (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/brand-report/reports/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_REPORTS_DATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadCSV (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/amc-reports/brand-report/download/${sellerId}`, {
            responseType: 'blob',
            params: {reportId: payload.id, reportType: payload.reportType}
          })
          const fileName = `AMCブランドレポート_${AMC_REPORT_TYPE[payload.reportType]}_${payload.reportName}.csv`
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleAmcBrandReports
